import classNames from "classnames";
import UtilityPageNav from "content-ui/utilityPages/components/utilityPageNav";
import ContactAndTeam from "./components/contactAndTeam";
import { Faq } from "components/faq/faq";
import Headline from "./components/headline";

const PitchYourStoryView = ({ data }) => {
  const innerContainerClasses = classNames(
    "relative flex flex-col md:mx-auto lg:pb-[100px] lg:flex-row md:max-w-[1040px] lg:max-w-[1220px] px-5 lg:px-0"
  );

  return (
    <main
      data-page-type="pitch-your-story"
      className="bg-[#F6F6F6] text-[16px] leading-[130%] text-black-rock"
    >
      <div className={innerContainerClasses}>
        <UtilityPageNav />

        <div className="mt-[1.25rem]">
          <Headline headline={data.headline} subhead={data.subhead} />
          <div className="flex flex-col lg:flex-col-reverse">
            <div className="flex flex-col gap-y-[70px]">
              <Faq title={data.storyTypesFaqHeading} faq={data.storyTypesFaq} />
              <Faq title={data.topicsFaqHeading} faq={data.topicsFaq} />
            </div>

            <ContactAndTeam data={data} />
          </div>
        </div>
      </div>
    </main>
  );
};

export default PitchYourStoryView;
